import { createFileRoute, redirect } from "@tanstack/react-router";

import { H2 } from "@/components/ui/typography";
import { handleReaderPatreonCallback } from "@/lib/api";

export const Route = createFileRoute("/app/patreon/connect")({
  validateSearch: (search: Record<string, unknown>) => ({
    code: search?.code as string | undefined,
  }),

  beforeLoad: async ({ search }) => {
    if (!search.code) {
      throw redirect({ to: "/app" });
    }

    const result = await handleReaderPatreonCallback(search.code);

    if (result.authorization_url) {
      window.location.href = result.authorization_url;
      return; // We won't reach rendering, but we need to return something
    }

    if (result.linked) {
      return { linked: true };
    }

    return { linked: false };
  },

  component: SuccessRoute,
});

function SuccessRoute() {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="flex flex-col gap-2">
        <H2 className="mb-2">Patreon and Bluesky linked!</H2>
        <p>For feeds you subscribe to, you can now receive member benefits.</p>
        <p className="text-sm text-slate-dim">You can now close this window.</p>
      </div>
    </div>
  );
}
